import React from "react";
import { Form, Row, Col } from "react-bootstrap";
import $ from "jquery";

const Password = (props) => {
    const { value1, value2, onChangeValue, option, arrangement, t } = props;
    return (
        <Row>
            <Col md={arrangement === "block" || !option || option === "single" ? 12 : 6} xs={12}>
                <Form.Label>
                    {t("form.pass")} <span className="required"> *</span>
                </Form.Label>
                <Form.Control
                    type="password"
                    id="password"
                    placeholder={t("form.typePass")}
                    name="password"
                    value={value1}
                    onChange={(e) => {
                        onChangeValue(e);
                        $(`#password`).removeClass("danger");
                    }}
                    autoComplete={value2 ? "new-password" : "nope"}
                    className="mb-3 req"
                />
            </Col>
            {option === "double" && (
                <Col md={arrangement === "block" ? 12 : 6} xs={12}>
                    <Form.Label>
                        {t("form.repeatPass")} <span className="required"> *</span>
                    </Form.Label>
                    <Form.Control
                        type="password"
                        id="repeatPassword"
                        placeholder={t("form.typeRepeatPass")}
                        name="repeatPassword"
                        value={value2}
                        onChange={(e) => {
                            onChangeValue(e);
                            $(`#repeatPassword`).removeClass("danger");
                        }}
                        autoComplete={"new-password"}
                        className="mb-3 req"
                    />
                </Col>
            )}
        </Row>
    );
};

export default Password;
